import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div`
    width: 100%;
`;

export const FunctionalityItem = styled.div<{ backgroundImg: string, icon: string }>`
    position: relative;
    height: 372px;
    width: 479px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    overflow: hidden;
    background-color: ${COLORS.GRAY_S};
    background-image: url('${p => p.backgroundImg}');
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;

    &:after {
        position: absolute;
        top: 24px;
        left: 26px;
        display: inline-block;
        content: "";
        background-image: url('${p => p.icon}');
        background-repeat: no-repeat;
        width: 56px;
        height: 56px;
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 391px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 327px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 307px;
    }
`;

export const Image = styled.img`
    width: 100%;
`;

export const DescWrap = styled.div`
    position: absolute;
    align-items: flex-end;
    width: 100%;
    height: 100%;
    padding: 32px 26px;
`;

export const DescInner = styled.div``;

export const Title = styled.p`
    ${FONTS.H4};
    color: ${COLORS.white};
`;

export const Text = styled.p`
    ${FONTS.XS};
    color: ${COLORS.white};
    margin-top: 6px;
    min-height: 60px;
`;
